<template>
  <v-row>
    <v-col cols="12">
      <v-card class="d-flex">
        <v-card-text>
          <v-card-title>基本情報</v-card-title>

          <!-- 配車計画の利用 -->
          <v-row>
            <v-col cols="12" md="6">
              <v-radio-group v-model="tenant.use_allocate" label="配車計画利用" row dense hide-details="auto" class="pa-0 ma-0">
                <v-radio label="利用する" :value="true" />
                <v-radio label="利用しない" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- /配車計画の利用 -->

          <!-- 売上請求管理 -->
          <v-row>
            <v-col cols="12" md="6">
              <v-radio-group v-model="tenant.use_billing" label="売上請求管理利用" row dense hide-details="auto"
                class="pa-0 ma-0">
                <v-radio label="利用する" :value=true />
                <v-radio label="利用しない" :value=false />
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- 売上請求管理 -->

          <!-- 利用モード -->
          <v-row>
            <v-col cols="12" md="6">
              <v-radio-group v-model="tenant.mode" label="利用モード" row dense hide-details="auto" class="pa-0 ma-0">
                <v-radio label="収運のみ" value="transport" />
                <v-radio label="収運・処分" value="transport_disposal" />
                <v-radio label="処分のみ" value="disposal" />
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- /利用モード -->

          <v-card-subtitle>{{ tenant.mode === 'disposal' ? '代表処分加入者' : '収運加入者' }}</v-card-subtitle>
          <v-row>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }"
                :rules="{ required: (tenant.subscriber_number), alpha_num_only: true, length: 7, subscriberNumberInitialsCheck: { mode: tenant.mode === 'disposal' ? 'admin_disposer' : 'admin_transport', contract_type: contractUnitType } }"
                :vid="`subscriber_number-${tabNumber}`" class="requiredMark" name="加入者番号">
                <v-text-field v-model="tenant.subscriber_number" :error-messages="errors" label="加入者番号"
                  persistent-placeholder required
                >
                  <template v-slot:label>
                    <span>加入者番号</span>
                    <span class="ml-1">
                      ({{ tenant.subscriber_number?.length || 0 }} / 7)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col v-if="!tenant._destroy" cols="12" md="3">
              <validation-provider v-slot="{ errors }"
                :rules="{ required: (tenant.confirmation_number), numeric: true, length: 6 }"
                :vid="`confirmation_number-${tabNumber}`" class="requiredMark" name="公開確認番号">
                <v-text-field v-model="tenant.confirmation_number" :error-messages="errors" label="公開確認番号"
                  persistent-placeholder required
                >
                  <template v-slot:label>
                    <span>公開確認番号</span>
                    <span class="ml-1">
                      ({{ tenant.confirmation_number?.length || 0 }} / 6)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col v-if="!tenant._destroy" cols="12" md="3">
              <validation-provider v-slot="{ errors }"
                :rules="{ required: (tenant.edi_usage_key), numeric: true, length: 8 }"
                :vid="`edi_usage_key-${tabNumber}`" class="requiredMark" name="EDI利用確認キー">
                <v-text-field v-model="tenant.edi_usage_key" :error-messages="errors" label="EDI利用確認キー"
                  persistent-placeholder required
                >
                  <template v-slot:label>
                    <span>EDI利用確認キー</span>
                    <span class="ml-1">
                      ({{ tenant.edi_usage_key?.length || 0 }} / 8)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>

          <v-expand-transition>
            <disposal-subscriber-form v-if="['transport_disposal', 'disposal'].includes(tenant.mode)" :tenant="tenant" :contract-unit-type="contractUnitType"
              @addButtonCallback="addDisposalSubscriber" @removeButtonCallback="removeDisposalSubscriber" />
          </v-expand-transition>

          <!-- 他社区間代行起票 -->
          <v-row>
            <v-col cols="12" md="6">
              <v-radio-group v-model="tenant.use_proxy_entry" label="他社区間代行起票" row dense hide-details="auto" class="pa-0 ma-0">
                <v-radio label="利用する" :value=true />
                <v-radio label="利用しない" :value=false />
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- /他社区間代行起票 -->

          <v-expand-transition>
            <proxy-entry-subscriber-form v-if="tenant.use_proxy_entry" :tenant="tenant" :contract-unit-type="contractUnitType"
              @addButtonCallback="addProxyEntrySubscriber" @removeButtonCallback="removeProxyEntrySubscriber" />
          </v-expand-transition>


          <!-- テナントコード -->
          <v-row v-if="tenant.id">
            <v-col cols="12" md="6">
              <div class="overline">
                テナントコード
              </div>
              <h4>{{ tenant.code }}&nbsp;</h4>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /テナントコード -->

          <!-- テナント名 -->
          <v-row>
            <v-col cols="12" md="6">
              <validation-provider v-slot="{ errors }" :vid="`name-${tabNumber}`" rules="required|max:50" name="テナント名"
                class="requiredMark">
                <v-text-field v-model="tenant.name" :error-messages="errors" label="テナント名"
                  hide-details="auto" persistent-placeholder required
                >
                  <template v-slot:label>
                    <span>テナント名</span>
                    <span class="ml-1">
                      ({{ tenant.name?.length || 0 }} / 50)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /テナント名-->

          <!-- テナント名フリガナ -->
          <v-row>
            <v-col cols="12" md="6">
              <validation-provider v-slot="{ errors }" :vid="`name_kana-${tabNumber}`"
                rules="required|katakana_only|max:50" name="テナント名フリガナ" class="requiredMark">
                <v-text-field v-model="tenant.name_kana" :error-messages="errors" label="テナント名フリガナ"
                  hide-details="auto" persistent-placeholder required
                >
                  <template v-slot:label>
                    <span>テナント名フリガナ</span>
                    <span class="ml-1">
                      ({{ tenant.name_kana?.length || 0 }} / 50)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /テナント名フリガナ-->

          <!-- 郵便番号 -->
          <v-row>
            <v-col cols="12" md="5">
              <validation-provider v-slot="{ errors }" :vid="`zip_code-${tabNumber}`" rules="required|zip_code|max:8"
                name="郵便番号" class="requiredMark">
                <v-text-field v-model="tenant.zip_code" :error-messages="errors" label="郵便番号"
                  hide-details="auto" hint="ハイフンを含めて入力してください" persistent-hint persistent-placeholder
                  placeholder="例）111-1111" required
                >
                  <template v-slot:label>
                    <span>郵便番号</span>
                    <span class="ml-1">
                      ({{ tenant.zip_code?.length || 0 }} / 8)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                  <template v-slot:append-outer>
                    <zip-code-search :zip-code="tenant.zip_code" @zipAddress="setZipAddress" />
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /郵便番号 -->

          <!-- 都道府県 -->
          <v-row>
            <v-col cols="12" md="4">
              <validation-provider v-slot="{ errors }" :vid="`prefecture_code-${tabNumber}`" name="都道府県">
                <v-autocomplete v-model="tenant.prefecture_code" :error-messages="errors" :items="prefList" item-text="text"
                  item-value="value" label="都道府県" persistent-placeholder required />
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /都道府県 -->

          <!-- 市区町村 -->
          <v-row>
            <v-col>
              <validation-provider v-slot="{ errors }" :vid="`address_1-${tabNumber}`"
                rules="required|full_width|max:20" name="市区町村" class="requiredMark">
                <v-text-field v-model="tenant.address_1" :error-messages="errors" label="市区町村"
                  hide-details="auto" persistent-placeholder required
                >
                  <template v-slot:label>
                    <span>市区町村</span>
                    <span class="ml-1">
                      ({{ tenant.address_1?.length || 0 }} / 20)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /市区町村 -->

          <!-- 町域 -->
          <v-row>
            <v-col>
              <validation-provider v-slot="{ errors }" :vid="`address_2-${tabNumber}`" rules="full_width|max:40"
                name="町域">
                <v-text-field v-model="tenant.address_2" :error-messages="errors" label="町域"
                  hide-details="auto" persistent-placeholder clearable
                >
                  <template v-slot:label>
                    <span>町域</span>
                    <span class="ml-1">
                      ({{ tenant.address_2?.length || 0 }} / 40)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /町域 -->

          <!-- 詳細住所 -->
          <v-row>
            <v-col>
              <validation-provider v-slot="{ errors }" :vid="`address_3-${tabNumber}`" rules="max:50" name="詳細住所">
                <v-text-field v-model="tenant.address_3" :error-messages="errors" label="詳細住所"
                  hide-details="auto" persistent-placeholder clearable
                >
                  <template v-slot:label>
                    <span>詳細住所</span>
                    <span class="ml-1">
                      ({{ tenant.address_3?.length || 0 }} / 50)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /詳細住所 -->

          <v-card-title>担当者情報</v-card-title>

          <!-- 担当者名 -->
          <v-row>
            <v-col cols="12" md="6">
              <validation-provider v-slot="{ errors }" :vid="`supervisor_last_name-${tabNumber}`" rules="required|max:6"
                name="担当者名（姓）" class="requiredMark">
                <v-text-field v-model="tenant.supervisor_last_name" :error-messages="errors" label="担当者名（姓）"
                  hide-details="auto" persistent-placeholder required
                >
                  <template v-slot:label>
                    <span>担当者名（姓）</span>
                    <span class="ml-1">
                      ({{ tenant.supervisor_last_name?.length || 0 }} / 6)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="6">
              <validation-provider v-slot="{ errors }" :vid="`supervisor_first_name-${tabNumber}`"
                rules="required|max:6" name="担当者名（名）" class="requiredMark">
                <v-text-field v-model="tenant.supervisor_first_name" :error-messages="errors" label="担当者名（名）"
                  hide-details="auto" persistent-placeholder required
                >
                  <template v-slot:label>
                    <span>担当者名（名）</span>
                    <span class="ml-1">
                      ({{ tenant.supervisor_first_name?.length || 0 }} / 6)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /担当者名 -->

          <!-- 担当者名フリガナ -->
          <v-row>
            <v-col cols="12" md="6">
              <validation-provider v-slot="{ errors }" :vid="`supervisor_last_name_kana-${tabNumber}`"
                rules="required|katakana_only|max:10" name="担当者名フリガナ（姓）" class="requiredMark">
                <v-text-field v-model="tenant.supervisor_last_name_kana" :error-messages="errors"
                  label="担当者名フリガナ（姓）" hide-details="auto" persistent-placeholder required
                >
                  <template v-slot:label>
                    <span>担当者名フリガナ（姓）</span>
                    <span class="ml-1">
                      ({{ tenant.supervisor_last_name_kana?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="6">
              <validation-provider v-slot="{ errors }" :vid="`supervisor_first_name_kana-${tabNumber}`"
                rules="required|katakana_only|max:10" name="担当者名フリガナ（名）" class="requiredMark">
                <v-text-field v-model="tenant.supervisor_first_name_kana" :error-messages="errors"
                  label="担当者名フリガナ（名）" hide-details="auto" persistent-placeholder required
                >
                  <template v-slot:label>
                    <span>担当者名フリガナ（名）</span>
                    <span class="ml-1">
                      ({{ tenant.supervisor_first_name_kana?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /担当者名フリガナ -->

          <!-- 担当者部署名 -->
          <v-row>
            <v-col cols="12" md="6">
              <validation-provider v-slot="{ errors }" :vid="`supervisor_department_name-${tabNumber}`" rules="max:20"
                name="担当者部署名">
                <v-text-field v-model="tenant.supervisor_department_name" :error-messages="errors"
                  label="担当者部署名" hide-details="auto" persistent-placeholder clearable
                >
                  <template v-slot:label>
                    <span>担当者部署名</span>
                    <span class="ml-1">
                      ({{ tenant.supervisor_department_name?.length || 0 }} / 20)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /担当者部署名-->

          <!-- 担当者電話番号/FAX -->
          <v-row>
            <v-col cols="12" md="6">
              <validation-provider v-slot="{ errors }" :vid="`supervisor_phone_number-${tabNumber}`"
                rules="required|numeric_hyphen_contract_only|max:15" name="担当者電話番号" class="requiredMark">
                <v-text-field v-model="tenant.supervisor_phone_number" :error-messages="errors"
                  label="担当者電話番号" hide-details="auto" persistent-placeholder required
                >
                  <template v-slot:label>
                    <span>担当者電話番号</span>
                    <span class="ml-1">
                      ({{ tenant.supervisor_phone_number?.length || 0 }} / 15)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="6">
              <validation-provider v-slot="{ errors }" :vid="`supervisor_fax_number-${tabNumber}`"
                rules="numeric_hyphen_contract_only|max:15" name="担当者FAX番号">
                <v-text-field v-model="tenant.supervisor_fax_number" :error-messages="errors" label="担当者FAX番号"
                  hide-details="auto" persistent-placeholder clearable
                >
                  <template v-slot:label>
                    <span>担当者FAX番号</span>
                    <span class="ml-1">
                      ({{ tenant.supervisor_fax_number?.length || 0 }} / 15)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /担当者電話番号/FAX -->

          <!-- 担当者携帯電話番号/メールアドレス -->
          <v-row>
            <v-col cols="12" md="6">
              <validation-provider v-slot="{ errors }" :vid="`supervisor_email-${tabNumber}`"
                rules="required|email|max:100" name="担当者メールアドレス" class="requiredMark">
                <v-text-field v-model="tenant.supervisor_email" :error-messages="errors" label="担当者メールアドレス"
                  hide-details="auto" persistent-placeholder required
                >
                  <template v-slot:label>
                    <span>担当者メールアドレス</span>
                    <span class="ml-1">
                      ({{ tenant.supervisor_email?.length || 0 }} / 100)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /担当者携帯電話番号/メールアドレス -->

          <v-row>
            <v-col cols="12" md="6">
              <v-radio-group v-model="tenant.use_ip_restrictions" label="IPアドレス制限" row dense hide-details="auto"
                class="pa-0 ma-0">
                <v-radio label="利用する" :value="true" />
                <v-radio label="利用しない" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>

          <!-- アクセスを許可するIP -->
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider v-slot="{ errors }" name="アクセスを許可するIP" :rules="{ required: (tenant.use_ip_restrictions),  max: 5120 }">
                <v-textarea v-model="tenant.allowed_ip_addresses" :disabled="!tenant.use_ip_restrictions"
                  :error-messages="errors" hide-details="auto" label="アクセスを許可するIP" persistent-placeholder
                  placeholder="例）127.0.0.1,192.1.0.0/24" rows="3"
                >
                  <template v-slot:label>
                    <span>アクセスを許可するIP</span>
                    <span class="ml-1">
                      ({{ tenant.allowed_ip_addresses?.length || 0 }} / 5120)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-textarea>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /アクセスを許可するIP -->

          <!-- 各種利用有無 -->
          <v-row>
            <v-col cols="12" md="6">
              <v-radio-group v-model="tenant.use_api" label="API使用有無" row dense hide-details="auto"
                class="pa-0 ma-0">
                <v-radio label="利用する" :value="true" />
                <v-radio label="利用しない" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="tenant.use_freee_claim"
                label="freee請求連携"
                row
                dense
                hide-details="auto"
                class="pa-0 ma-0"
              >
                <v-radio label="利用する" :value="true" />
                <v-radio label="利用しない" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="tenant.use_jwnet_transfer"
                label="JWNETデータ取込利用有無"
                row
                dense
                hide-details="auto"
                class="pa-0 ma-0"
              >
                <v-radio label="利用する" :value="true" />
                <v-radio label="利用しない" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-radio-group
                v-model="tenant.use_recycling"
                label="再資源法令適用"
                row
                dense
                hide-details="auto"
                class="pa-0 ma-0"
              >
                <v-radio label="利用する" :value="true" />
                <v-radio label="利用しない" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- /各種利用有無 -->

          <v-card-title>請求情報（基本料金）</v-card-title>
          <!-- 正式契約日 -->
          <v-row>
            <v-col v-if="!tenant.exists_invoice" cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.formally_contract_date"
                :minimum-date="systemDate"
                @dateChangedCallback="formallyContractDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :class="{ requiredMark: contractUnitType === 'formally_contract' }"
                    :rules="{ required: contractUnitType === 'formally_contract', chkFormallyContractDate: { systemDate, registed_formally_contract_date } }"
                    :vid="`formally_contract_date-${tabNumber}`" 
                    name="正式契約日"
                  >
                    <v-text-field
                      v-model="tenant.formally_contract_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="正式契約日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required 
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                正式契約日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.formally_contract_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /正式契約日 -->
          <!-- 請求開始日・請求無料期間 -->
          <v-row>
            <v-col cols="12" md="4">
              <div class="overline">
                請求開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.invoice_start_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col v-if="!tenant.exists_invoice" cols="12" md="4">
              <v-select v-model="tenant.invoice_free_term" :items="invoiceFreeTerms" label="請求無料期間" hide-details="auto"
                persistent-placeholder />
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求無料期間
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.invoice_free_term_name }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /請求開始日・請求無料期間 -->
          <!-- 支払方法種別・月額料金改定日・月額改定利用料金 -->
          <v-row>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`price_plan-${tabNumber}`" name="料金プラン" rules="required"
                class="requiredMark">
                <v-select v-model="tenant.price_plan" :items="pricePlans" :error-messages="errors" label="料金プラン"
                  hide-details="auto" persistent-placeholder />
              </validation-provider>
            </v-col>
            <v-col v-if="paymentType === 'payment_tenant' && tenant.paid_id === null" cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`payment_method_type-${tabNumber}`" name="支払方法種別" rules>
                <v-select v-model="tenant.payment_method_type" :items="paymentMethodTypes" :error-messages="errors"
                  label="支払方法種別" hide-details="auto" persistent-placeholder />
              </validation-provider>
            </v-col>
            <v-col v-else-if="paymentType === 'payment_tenant' && tenant.paid_id !== null" cols="12" md="3">
              <div class="overline">
                支払方法種別
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.payment_method_type_name }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`saas_monthly_price-${tabNumber}`"
                :class="{ requiredMark: tenant.formally_contract_date != null}"
                :rules="{ required: tenant.formally_contract_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額利用料金">
                <v-text-field v-model="tenant.saas_monthly_price" :error-messages="errors" clearable
                  label="月額利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.saas_monthly_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>                  
                  <template v-slot:append-outer>
                    <v-btn small color="primary" @click="monthlyUsageFee">
                      月額料金計算
                    </v-btn>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <cs-date-picker
                :date.sync="tenant.saas_price_rev_date"
                :minimum-date="systemDate"
                @dateChangedCallback="saasPriceRevDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :vid="`saas_price_rev_date-${tabNumber}`"
                    :class="{ requiredMark: tenant.saas_monthly_rev_price != null}"
                    :rules="{ required: tenant.saas_monthly_rev_price != null}" 
                    name="月額料金改定日"
                  >
                    <v-text-field
                      v-model="tenant.saas_price_rev_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="月額料金改定日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`saas_monthly_rev_price-${tabNumber}`"
                :class="{ requiredMark: tenant.saas_price_rev_date != null }"
                :rules="{ required: tenant.saas_price_rev_date != null , max: 10, numeric: true, max_value: 2147483647 }" name="月額改定利用料金">
                <v-text-field v-model="tenant.saas_monthly_rev_price" :error-messages="errors" clearable
                  label="月額改定利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額改定利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.saas_monthly_rev_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>         
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /支払方法種別・月額料金改定日・月額改定利用料金 -->

          <!-- Paid ID・Paid 連携日時 -->
          <v-row v-if="tenant.paid_id !== null">
            <v-col cols="12" md="4">
              <div class="overline" style="text-transform: none">
                Paid ID
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.paid_id }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col cols="12" md="4">
              <div class="overline" style="text-transform: none">
                Paid連携日時
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.paid_connect_at }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <!-- Paid 連携利用 -->
            <v-col cols="12" md="4">
              <v-radio-group v-model="tenant.use_paid" label="Paid連携利用" row dense hide-details="auto" class="pa-0 ma-0">
                <v-radio label="利用する" :value="true" />
                <v-radio label="利用しない" :value="false" />
              </v-radio-group>
            </v-col>
            <!-- /Paid 連携利用 -->
          </v-row>
          <!-- /Paid ID・Paid 連携日時 -->
          <!-- サービス利用停止日 -->
          <v-row>
            <v-col cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.service_stop_date"
                :minimum-date="systemDate"
                @dateChangedCallback="serviceStopDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <v-text-field
                    v-model="tenant.service_stop_date"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    hide-details="auto"
                    label="サービス利用停止日"
                    persistent-hint
                    persistent-placeholder
                    readonly
                    required
                  />
                </template>
              </cs-date-picker>
            </v-col>
          </v-row>
          <!-- /サービス利用停止日 -->

          <br />
          <v-card-title>請求情報（電子契約）</v-card-title>
          <!-- 電子契約利用開始日・終了日 -->
          <v-row>
            <v-col v-if="!tenant.exists_ec_contract_invoice"  cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.ec_contract_start_date"
                :minimum-date="systemDate"
                @dateChangedCallback="ecContractStartDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{ ecContactStartDateCheck: { ec_contract_end_date: tenant.ec_contract_end_date } }"
                    name="電子契約利用開始日"
                  >
                    <v-text-field
                      v-model="tenant.ec_contract_start_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="電子契約利用開始日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                電子契約利用開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.ec_contract_start_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>

            <v-col cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.ec_contract_end_date"
                :minimum-date="systemDate"
                @dateChangedCallback="ecContractEndDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <v-text-field
                    v-model="tenant.ec_contract_end_date"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    hide-details="auto"
                    label="電子契約利用終了日"
                    persistent-hint
                    persistent-placeholder
                    readonly
                    required
                  />
                </template>
              </cs-date-picker>
            </v-col>
          </v-row>
          <!-- /電子契約利用開始日・終了日 -->
          <!-- 電子契約請求開始日・電子契約請求無料期間 -->
          <v-row>
            <v-col v-if="!tenant.exists_ec_contract_invoice" cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.ec_contract_invoice_start_date"
                type="month"
                @dateChangedCallback="ecContractInvoiceStartDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                    <v-text-field
                      v-model="tenant.ec_contract_invoice_start_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="請求開始日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      @click:clear="picker_ecContract_date = null"
                    />
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.ec_contract_invoice_start_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col v-if="!tenant.exists_ec_contract_invoice" cols="12" md="4">
              <v-select v-model="tenant.ec_contract_invoice_free_term" :items="ecContractInvoiceFreeTerms" label="請求無料期間"
                hide-details="auto" persistent-placeholder />
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求無料期間
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.ec_contract_invoice_free_term_name }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /電子契約請求開始日・電子契約請求無料期間 -->
          <!-- 電子契約料金プラン・電子契約月額利用料金・月額料金改定日・月額改定利用料金 -->
          <v-row>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`ec_contract_price_plan-${tabNumber}`"
                :class="{ requiredMark: tenant.ec_contract_invoice_start_date }"
                :rules="{ required: tenant.ec_contract_invoice_start_date }" name="料金プラン">
                <v-select v-model="tenant.ec_contract_price_plan" :items="ecContractPricePlans" :error-messages="errors" label="料金プラン"
                  hide-details="auto" persistent-placeholder />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`ec_contract_monthly_price-${tabNumber}`"
                :class="{ requiredMark: tenant.ec_contract_invoice_start_date != null}"
                :rules="{ required: tenant.ec_contract_invoice_start_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額利用料金">
                <v-text-field v-model="tenant.ec_contract_monthly_price" :error-messages="errors" clearable
                  label="月額利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.ec_contract_monthly_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <cs-date-picker
                :date.sync="tenant.ec_contract_price_rev_date"
                :minimum-date="systemDate"
                @dateChangedCallback="ecContractPriceRevDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :vid="`ec_contract_price_rev_date-${tabNumber}`"
                    :class="{ requiredMark: tenant.ec_contract_monthly_rev_price != null}"
                    :rules="{ required: tenant.ec_contract_monthly_rev_price != null}" 
                    name="月額料金改定日"
                  >
                    <v-text-field
                      v-model="tenant.ec_contract_price_rev_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="月額料金改定日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`ec_contract_monthly_rev_price-${tabNumber}`"
                :class="{ requiredMark: tenant.ec_contract_price_rev_date != null}"
                :rules="{ required: tenant.ec_contract_price_rev_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額改定利用料金">
                <v-text-field v-model="tenant.ec_contract_monthly_rev_price" :error-messages="errors" clearable
                  label="月額改定利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額改定利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.ec_contract_monthly_rev_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /電子契約料金プラン・電子契約月額利用料金・月額料金改定日・月額改定利用料金 -->

          <v-card-title>請求情報（IPアドレス制限）</v-card-title>
          <!-- IPアドレス制限利用開始日・IPアドレス制限利用終了日 -->
          <v-row>
            <v-col v-if="!tenant.exists_ip_restrictions_invoice" cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.ip_restrictions_formally_contract_date"
                :minimum-date="systemDate"
                @dateChangedCallback="ipRestrictionsFormallyContractDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{ ipRestrictionsStartDateCheck: { ip_restrictions_service_stop_date: tenant.ip_restrictions_service_stop_date } }"
                    name="IPアドレス制限利用開始日"
                  >
                    <v-text-field
                      v-model="tenant.ip_restrictions_formally_contract_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="IPアドレス制限利用開始日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                IPアドレス制限利用開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.ip_restrictions_formally_contract_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.ip_restrictions_service_stop_date"
                :minimum-date="systemDate"
                @dateChangedCallback="ipRestrictionsServiceStopDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <v-text-field
                    v-model="tenant.ip_restrictions_service_stop_date"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    hide-details="auto"
                    label="IPアドレス制限利用終了日"
                    persistent-hint
                    persistent-placeholder
                    readonly
                    required
                  />
                </template>
              </cs-date-picker>
            </v-col>
          </v-row>
          <!-- /IPアドレス制限利用開始日・IPアドレス制限利用終了日 -->
          <!-- IPアドレス制限請求開始日・IPアドレス制限請求無料期間 -->
          <v-row>
            <v-col v-if="!tenant.exists_ip_restrictions_invoice" cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.ip_restrictions_invoice_start_date"
                type="month"
                @dateChangedCallback="ipRestrictionsInvoiceStartDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <v-text-field
                    v-model="tenant.ip_restrictions_invoice_start_date"
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="errors"
                    clearable
                    hide-details="auto"
                    label="請求開始日"
                    persistent-hint
                    persistent-placeholder
                    readonly
                    @click:clear="picker_ipRestrictions_date = null"
                  />
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.ip_restrictions_invoice_start_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col v-if="!tenant.exists_ip_restrictions_invoice" cols="12" md="4">
              <v-select v-model="tenant.ip_restrictions_invoice_free_term" :items="ipRestrictionsInvoiceFreeTerms" label="請求無料期間" hide-details="auto"
                persistent-placeholder />
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求無料期間
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.ip_restrictions_invoice_free_term_name }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /IPアドレス制限請求開始日・IPアドレス制限請求無料期間 -->
          <!-- IPアドレス制限料金プラン・IPアドレス制限月額利用料金・月額料金改定日・月額改定利用料金 -->
          <v-row>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`ip_restrictions_price_plan-${tabNumber}`" name="料金プラン"
                :class="{ requiredMark: tenant.ip_restrictions_invoice_start_date != null}"
                :rules="{ required: tenant.ip_restrictions_invoice_start_date != null}">
                <v-select v-model="tenant.ip_restrictions_price_plan" :items="ipRestrictionsPricePlans" :error-messages="errors" label="料金プラン"
                  hide-details="auto" persistent-placeholder />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`ip_restrictions_monthly_price-${tabNumber}`"
                :class="{ requiredMark: tenant.ip_restrictions_invoice_start_date != null}"
                :rules="{ required: tenant.ip_restrictions_invoice_start_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額利用料金">
                <v-text-field v-model="tenant.ip_restrictions_monthly_price" :error-messages="errors" clearable
                  label="月額利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.ip_restrictions_monthly_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <cs-date-picker
                :date.sync="tenant.ip_restrictions_price_rev_date"
                :minimum-date="systemDate"
                @dateChangedCallback="ipRestrictionsPriceRevDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :vid="`ip_restrictions_price_rev_date-${tabNumber}`"
                    :class="{ requiredMark: tenant.ip_restrictions_monthly_rev_price != null}"
                    :rules="{ required: tenant.ip_restrictions_monthly_rev_price != null}" 
                    name="月額料金改定日"
                  >
                    <v-text-field
                      v-model="tenant.ip_restrictions_price_rev_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="月額料金改定日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`ip_restrictions_monthly_rev_price-${tabNumber}`"
                :class="{ requiredMark: tenant.ip_restrictions_price_rev_date != null }"
                :rules="{ required: tenant.ip_restrictions_price_rev_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額改定利用料金">
                <v-text-field v-model="tenant.ip_restrictions_monthly_rev_price" :error-messages="errors" clearable
                  label="月額改定利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額改定利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.ip_restrictions_monthly_rev_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /IPアドレス制限料金プラン・IPアドレス制限月額利用料金・月額料金改定日・月額改定利用料金 -->

          <v-card-title>請求情報（API）</v-card-title>
          <!-- API利用開始日・API利用終了日 -->
          <v-row>
            <v-col v-if="!tenant.exists_api_invoice" cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.api_start_date"
                :minimum-date="systemDate"
                @dateChangedCallback="apiStartDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{ apiStartDateCheck: { api_end_date: tenant.api_end_date } }"
                    name="API利用開始日"
                  >
                    <v-text-field
                      v-model="tenant.api_start_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="API利用開始日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                API利用開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.api_start_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.api_end_date"
                :minimum-date="systemDate"
                @dateChangedCallback="apiEndDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <v-text-field
                    v-model="tenant.api_end_date"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    hide-details="auto"
                    label="API利用終了日"
                    persistent-hint
                    persistent-placeholder
                    readonly
                    required
                  />
                </template>
              </cs-date-picker>
            </v-col>
          </v-row>
          <!-- /API利用開始日・API利用終了日 -->
          <!-- API請求開始日・API請求無料期間 -->
          <v-row>
            <v-col v-if="!tenant.exists_api_invoice" cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.api_invoice_start_date"
                type="month"
                @dateChangedCallback="apiInvoiceStartDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <v-text-field
                    v-model="tenant.api_invoice_start_date"
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="errors"
                    clearable
                    hide-details="auto"
                    label="請求開始日"
                    persistent-hint
                    persistent-placeholder
                    readonly
                    @click:clear="picker_api_date = null"
                  />
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.api_invoice_start_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col v-if="!tenant.exists_api_invoice" cols="12" md="4">
              <v-select v-model="tenant.api_invoice_free_term" :items="apiInvoiceFreeTerms" label="請求無料期間" hide-details="auto"
                persistent-placeholder />
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求無料期間
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.api_invoice_free_term_name }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /API請求開始日・API請求無料期間 -->
          <!-- API料金プラン・API月額利用料金・月額料金改定日・月額改定利用料金 -->
          <v-row>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`api_price_plan-${tabNumber}`" name="料金プラン"
                :class="{ requiredMark: tenant.api_invoice_start_date != null}"
                :rules="{ required: tenant.api_invoice_start_date != null }">
                <v-select v-model="tenant.api_price_plan" :items="apiPricePlans" :error-messages="errors" label="料金プラン"
                  hide-details="auto" persistent-placeholder />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`api_monthly_price-${tabNumber}`"
                :class="{ requiredMark: tenant.api_invoice_start_date != null}"
                :rules="{ required: tenant.api_invoice_start_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額利用料金">
                <v-text-field v-model="tenant.api_monthly_price" :error-messages="errors" clearable
                  label="月額利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.api_monthly_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <cs-date-picker
                :date.sync="tenant.api_price_rev_date"
                :minimum-date="systemDate"
                @dateChangedCallback="apiPriceRevDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :vid="`api_price_rev_date-${tabNumber}`"
                    :class="{ requiredMark: tenant.api_monthly_rev_price != null}"
                    :rules="{ required: tenant.api_monthly_rev_price != null }" 
                    name="月額料金改定日"
                  >
                    <v-text-field
                      v-model="tenant.api_price_rev_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="月額料金改定日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`api_monthly_rev_price-${tabNumber}`"
                :class="{ requiredMark: tenant.api_price_rev_date != null}"
                :rules="{ required: tenant.api_price_rev_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額改定利用料金">
                <v-text-field v-model="tenant.api_monthly_rev_price" :error-messages="errors" clearable
                  label="月額改定利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額改定利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.api_monthly_rev_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /API制限料金プラン・API月額利用料金・月額料金改定日・月額改定利用料金 -->
          <v-card-title>請求情報（freee請求連携）</v-card-title>

          <!-- freee利用開始日・freee利用終了日 -->
          <v-row>
            <v-col v-if="!tenant.exists_freee_invoice" cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.freee_start_date"
                :minimum-date="systemDate"
                @dateChangedCallback="freeeStartDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{ freeeStartDateCheck: { freee_end_date: tenant.freee_end_date } }"
                    name="freee利用開始日"
                  >
                    <v-text-field
                      v-model="tenant.freee_start_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="freee利用開始日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                freee利用開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.freee_start_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.freee_end_date"
                :minimum-date="systemDate"
                @dateChangedCallback="freeeEndDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <v-text-field
                    v-model="tenant.freee_end_date"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    hide-details="auto"
                    label="freee利用終了日"
                    persistent-hint
                    persistent-placeholder
                    readonly
                    required
                  />
                </template>
              </cs-date-picker>
            </v-col>
          </v-row>
          <!-- /freee利用開始日・freee利用終了日 -->
          <!-- freee請求開始日・freee請求無料期間 -->
          <v-row>
            <v-col v-if="!tenant.exists_freee_invoice" cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.freee_invoice_start_date"
                type="month"
                @dateChangedCallback="freeeInvoiceStartDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <v-text-field
                    v-model="tenant.freee_invoice_start_date"
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="errors"
                    clearable
                    hide-details="auto"
                    label="請求開始日"
                    persistent-hint
                    persistent-placeholder
                    readonly
                    @click:clear="picker_freee_date = null"
                  />
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.freee_invoice_start_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col v-if="!tenant.exists_freee_invoice" cols="12" md="4">
              <v-select v-model="tenant.freee_invoice_free_term" :items="freeeInvoiceFreeTerms" label="請求無料期間" hide-details="auto"
                persistent-placeholder />
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求無料期間
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.freee_invoice_free_term_name }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /freee請求開始日・freee請求無料期間 -->
          <!-- freee料金プラン・freee月額利用料金・月額料金改定日・月額改定利用料金 -->
          <v-row>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`freee_price_plan-${tabNumber}`" name="料金プラン"
                :class="{ requiredMark: tenant.freee_invoice_start_date != null }"
                :rules="{ required: tenant.freee_invoice_start_date != null }">
                <v-select v-model="tenant.freee_price_plan" :items="freeePricePlans" :error-messages="errors" label="料金プラン"
                  hide-details="auto" persistent-placeholder />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`freee_monthly_price-${tabNumber}`"
                :class="{ requiredMark: tenant.freee_invoice_start_date != null}"
                :rules="{ required: tenant.freee_invoice_start_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額利用料金">
                <v-text-field v-model="tenant.freee_monthly_price" :error-messages="errors" clearable
                  label="月額利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.freee_monthly_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <cs-date-picker
                :date.sync="tenant.freee_price_rev_date"
                :minimum-date="systemDate"
                @dateChangedCallback="freeePriceRevDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :vid="`freee_price_rev_date-${tabNumber}`"
                    :class="{ requiredMark: tenant.freee_monthly_rev_price != null }"
                    :rules="{ required: tenant.freee_monthly_rev_price != null }" 
                    name="月額料金改定日"
                  >
                    <v-text-field
                      v-model="tenant.freee_price_rev_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="月額料金改定日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`freee_monthly_rev_price-${tabNumber}`"
                :class="{ requiredMark: tenant.freee_price_rev_date != null}"
                :rules="{ required: tenant.freee_price_rev_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額改定利用料金">
                <v-text-field v-model="tenant.freee_monthly_rev_price" :error-messages="errors" clearable
                  label="月額改定利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額改定利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.freee_monthly_rev_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /freee制限料金プラン・freee月額利用料金・月額料金改定日・月額改定利用料金 -->

          <v-card-title>請求情報（JWNETデータ取込）</v-card-title>

          <!-- JWNETデータ取込利用開始日・JWNETデータ取込利用終了日 -->
          <v-row>
            <v-col v-if="!tenant.exists_jwnet_transfer_invoice" cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.jwnet_transfer_start_date"
                :minimum-date="systemDate"
                @dateChangedCallback="jwnetTransferStartDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{ jwnetTransferStartDateCheck: { jwnet_transfer_end_date: tenant.jwnet_transfer_end_date } }"
                    name="JWNETデータ取込利用開始日"
                  >
                    <v-text-field
                      v-model="tenant.jwnet_transfer_start_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="JWNETデータ取込利用開始日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                JWNETデータ取込利用開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.jwnet_transfer_start_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.jwnet_transfer_end_date"
                :minimum-date="systemDate"
                @dateChangedCallback="jwnetTransferEndDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <v-text-field
                    v-model="tenant.jwnet_transfer_end_date"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    hide-details="auto"
                    label="JWNETデータ取込利用終了日"
                    persistent-hint
                    persistent-placeholder
                    readonly
                    required
                  />
                </template>
              </cs-date-picker>
            </v-col>
          </v-row>
          <!-- /JWNETデータ取込利用開始日・JWNETデータ取込利用終了日 -->
          <!-- JWNETデータ取込請求開始日・JWNETデータ取込請求無料期間 -->
          <v-row>
            <v-col v-if="!tenant.exists_jwnet_transfer_invoice" cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.jwnet_transfer_invoice_start_date"
                type="month"
                @dateChangedCallback="jwnetTransferInvoiceStartDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <v-text-field
                    v-model="tenant.jwnet_transfer_invoice_start_date"
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="errors"
                    clearable
                    hide-details="auto"
                    label="請求開始日"
                    persistent-hint
                    persistent-placeholder
                    readonly
                    @click:clear="picker_jwnet_transfer_date = null"
                  />
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.jwnet_transfer_invoice_start_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col v-if="!tenant.exists_jwnet_transfer_invoice" cols="12" md="4">
              <v-select v-model="tenant.jwnet_transfer_invoice_free_term" :items="jwnetTransferInvoiceFreeTerms" label="請求無料期間" hide-details="auto"
                persistent-placeholder />
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求無料期間
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.jwnet_transfer_invoice_free_term_name }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /JWNETデータ取込請求開始日・JWNETデータ取込請求無料期間 -->
          <!-- JWNETデータ取込料金プラン・JWNETデータ取込月額利用料金・月額料金改定日・月額改定利用料金 -->
          <v-row>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`jwnet_transfer_price_plan-${tabNumber}`" name="料金プラン"
                :class="{ requiredMark: tenant.jwnet_transfer_invoice_start_date != null }"
                :rules="{ required: tenant.jwnet_transfer_invoice_start_date != null }">
                <v-select v-model="tenant.jwnet_transfer_price_plan" :items="jwnetTransferPricePlans" :error-messages="errors" label="料金プラン"
                  hide-details="auto" persistent-placeholder />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`jwnet_transfer_monthly_price-${tabNumber}`"
                :class="{ requiredMark: tenant.jwnet_transfer_invoice_start_date != null}"
                :rules="{ required: tenant.jwnet_transfer_invoice_start_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額利用料金">
                <v-text-field v-model="tenant.jwnet_transfer_monthly_price" :error-messages="errors" clearable
                  label="月額利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.jwnet_transfer_monthly_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <cs-date-picker
                :date.sync="tenant.jwnet_transfer_price_rev_date"
                :minimum-date="systemDate"
                @dateChangedCallback="jwnetTransferPriceRevDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :vid="`jwnet_transfer_price_rev_date-${tabNumber}`"
                    :class="{ requiredMark: tenant.jwnet_transfer_monthly_rev_price != null }"
                    :rules="{ required: tenant.jwnet_transfer_monthly_rev_price != null }" 
                    name="月額料金改定日"
                  >
                    <v-text-field
                      v-model="tenant.jwnet_transfer_price_rev_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="月額料金改定日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`jwnet_transfer_monthly_rev_price-${tabNumber}`"
                :class="{ requiredMark: tenant.jwnet_transfer_price_rev_date != null}"
                :rules="{ required: tenant.jwnet_transfer_price_rev_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額改定利用料金">
                <v-text-field v-model="tenant.jwnet_transfer_monthly_rev_price" :error-messages="errors" clearable
                  label="月額改定利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額改定利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.jwnet_transfer_monthly_rev_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /JWNETデータ取込制限料金プラン・JWNETデータ取込月額利用料金・月額料金改定日・月額改定利用料金 -->

          <v-card-title>請求情報（他社区間代行起票）</v-card-title>

          <!-- 他社区間代行起票利用開始日・他社区間代行起票利用終了日 -->
          <v-row>
            <v-col v-if="!tenant.exists_proxy_entry_invoice" cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.proxy_entry_start_date"
                :minimum-date="systemDate"
                @dateChangedCallback="proxyEntryStartDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{ proxyEntryStartDateCheck: { proxy_entry_end_date: tenant.proxy_entry_end_date } }"
                    name="他社区間代行起票利用開始日"
                  >
                    <v-text-field
                      v-model="tenant.proxy_entry_start_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="他社区間代行起票利用開始日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                他社区間代行起票利用開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.proxy_entry_start_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.proxy_entry_end_date"
                :minimum-date="systemDate"
                @dateChangedCallback="proxyEntryEndDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <v-text-field
                    v-model="tenant.proxy_entry_end_date"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    hide-details="auto"
                    label="他社区間代行起票利用終了日"
                    persistent-hint
                    persistent-placeholder
                    readonly
                    required
                  />
                </template>
              </cs-date-picker>
            </v-col>
          </v-row>
          <!-- /他社区間代行起票利用開始日・他社区間代行起票利用終了日 -->
          <!-- 他社区間代行起票請求開始日・他社区間代行起票請求無料期間 -->
          <v-row>
            <v-col v-if="!tenant.exists_proxy_entry_invoice" cols="12" md="4">
              <cs-date-picker
                :date.sync="tenant.proxy_entry_invoice_start_date"
                type="month"
                @dateChangedCallback="proxyEntryInvoiceStartDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <v-text-field
                    v-model="tenant.proxy_entry_invoice_start_date"
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="errors"
                    clearable
                    hide-details="auto"
                    label="請求開始日"
                    persistent-hint
                    persistent-placeholder
                    readonly
                    @click:clear="picker_proxy_entry_date = null"
                  />
                </template>
              </cs-date-picker>
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求開始日
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.proxy_entry_invoice_start_date | date_format }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
            <v-col v-if="!tenant.exists_proxy_entry_invoice" cols="12" md="4">
              <v-select v-model="tenant.proxy_entry_invoice_free_term" :items="proxyEntryInvoiceFreeTerms" label="請求無料期間" hide-details="auto"
                persistent-placeholder />
            </v-col>
            <v-col v-else cols="12" md="4">
              <div class="overline">
                請求無料期間
              </div>
              <h3 class="font-weight-medium black--text">
                {{ tenant.proxy_entry_invoice_free_term_name }}&nbsp;
              </h3>
              <v-divider />
            </v-col>
          </v-row>
          <!-- /他社区間代行起票請求開始日・他社区間代行起票請求無料期間 -->
          <!-- 他社区間代行起票料金プラン・他社区間代行起票月額利用料金・月額料金改定日・月額改定利用料金 -->
          <v-row>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`proxy_entry_price_plan-${tabNumber}`" name="料金プラン"
                :class="{ requiredMark: tenant.proxy_entry_invoice_start_date != null }"
                :rules="{ required: tenant.proxy_entry_invoice_start_date != null }">
                <v-select v-model="tenant.proxy_entry_price_plan" :items="proxyEntryPricePlans" :error-messages="errors" label="料金プラン"
                  hide-details="auto" persistent-placeholder />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`proxy_entry_monthly_price-${tabNumber}`"
                :class="{ requiredMark: tenant.proxy_entry_invoice_start_date != null}"
                :rules="{ required: tenant.proxy_entry_invoice_start_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額利用料金">
                <v-text-field v-model="tenant.proxy_entry_monthly_price" :error-messages="errors" clearable
                  label="月額利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.proxy_entry_monthly_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="3">
              <cs-date-picker
                :date.sync="tenant.proxy_entry_price_rev_date"
                :minimum-date="systemDate"
                @dateChangedCallback="proxyEntryPriceRevDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :vid="`proxy_entry_price_rev_date-${tabNumber}`"
                    :class="{ requiredMark: tenant.proxy_entry_monthly_rev_price != null }"
                    :rules="{ required: tenant.proxy_entry_monthly_rev_price != null }" 
                    name="月額料金改定日"
                  >
                    <v-text-field
                      v-model="tenant.proxy_entry_price_rev_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      clearable
                      hide-details="auto"
                      label="月額料金改定日"
                      persistent-hint
                      persistent-placeholder
                      readonly
                      required
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider v-slot="{ errors }" :vid="`proxy_entry_monthly_rev_price-${tabNumber}`"
                :class="{ requiredMark: tenant.proxy_entry_price_rev_date != null}"
                :rules="{ required: tenant.proxy_entry_price_rev_date != null, max: 10, numeric: true, max_value: 2147483647 }" name="月額改定利用料金">
                <v-text-field v-model="tenant.proxy_entry_monthly_rev_price" :error-messages="errors" clearable
                  label="月額改定利用料金" hide-details="auto" persistent-placeholder
                >
                  <template v-slot:label>
                    <span>月額改定利用料金</span>
                    <span class="ml-1">
                      ({{ tenant.proxy_entry_monthly_rev_price?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /他社区間代行起票料金プラン・他社区間代行起票月額利用料金・月額料金改定日・月額改定利用料金 -->

          <!-- 他社区間代行起票条件 -->
          <v-row>
            <v-col>
              <validation-provider v-slot="{ errors }" :vid="`proxy_entry_condition-${tabNumber}`" rules="max:200" name="条件">
                <v-text-field v-model="tenant.proxy_entry_condition" :error-messages="errors" hide-details="auto"
                  label="条件" persistent-placeholder rows="3" 
                >
                  <template v-slot:label>
                    <span>条件</span>
                    <span class="ml-1">
                      ({{ tenant.proxy_entry_condition?.length || 0 }} / 200)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /他社区間代行起票条件 -->

          <v-card-title>請求情報（その他請求）</v-card-title>
          <!-- その他金額・その他請求適用日・その他タイトル -->
          <v-expand-transition>
            <invoice-other-form :tenant="tenant"
              @addButtonCallback="addInvoiceOther" @removeButtonCallback="removeInvoiceOther" />
          </v-expand-transition>
          <!-- /その他金額・その他請求適用日・その他タイトル -->
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>

import PrefectureList from '../../../mixins/PrefectureList'
import ZipCodeSearch from '../../../components/ZipCodeSearch'
import DisposalSubscriberForm from './_disposalSubscriberForm'
import ProxyEntrySubscriberForm from './_proxyEntrySubscriberForm'
import InvoiceOtherForm from './_invoiceOtherForm'
import moment from 'moment'

export default {
  name: 'TenantForm',
  components: {
    ZipCodeSearch,
    DisposalSubscriberForm,
    ProxyEntrySubscriberForm,
    InvoiceOtherForm
  },
  mixins: [PrefectureList],
  props: {
    tenant: {
      type: Object,
      default: () => {
        return {}
      },

    },
    paymentType: {
      type: String,
      default: "payment_contractor"
    },
    contractUnitType: {
      type: String,
      default: "trial_contract"
    },
    invoiceFreeTerms: {
      type: Array,
      default: () => []
    },
    ecContractInvoiceFreeTerms: {
      type: Array,
      default: () => []
    },
    ipRestrictionsInvoiceFreeTerms: {
      type: Array,
      default: () => []
    },
    apiInvoiceFreeTerms: {
      type: Array,
      default: () => []
    },
    freeeInvoiceFreeTerms: {
      type: Array,
      default: () => []
    },
    jwnetTransferInvoiceFreeTerms: {
      type: Array,
      default: () => []
    },
    proxyEntryInvoiceFreeTerms: {
      type: Array,
      default: () => []
    },
    paymentMethodTypes: {
      type: Array,
      default: () => []
    },
    pricePlans: {
      type: Array,
      default: () => []
    },
    ecContractPricePlans: {
      type: Array,
      default: () => []
    },
    ipRestrictionsPricePlans: {
      type: Array,
      default: () => []
    },
    apiPricePlans: {
      type: Array,
      default: () => []
    },
    freeePricePlans: {
      type: Array,
      default: () => []
    },
    jwnetTransferPricePlans: {
      type: Array,
      default: () => []
    },
    proxyEntryPricePlans: {
      type: Array,
      default: () => []
    },
    tabNumber: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      systemDate: moment().format("YYYY-MM-DD"),
      systemMonth: moment().format("YYYY-MM"),
      registed_formally_contract_date: "",
      ecContractDatePicker: "",
      ipRestrictionsDatePicker: "",
      apiDatePicker: "",
      picker_ecContract_date: "",
      picker_ipRestrictions_date: "",
      picker_api_date: "",
      freeeDatePicker: "",
      picker_freee_date: "",
      jwnetTransferDatePicker: "",
      picker_jwnet_transfer_date: "",
      proxyEntryDatePicker: "",
      picker_proxy_entry_date: "",
    }
  },
  computed: {},
  watch: {
    // 請求開始日は正式契約日の翌月１日
    'tenant.formally_contract_date': function (newVal) {
      let invoice_start_date = ''
      if (newVal !== null) {
        invoice_start_date = moment(newVal).add(1, 'months').format('YYYY-MM') + '-01'
      }
      this.tenant.invoice_start_date = invoice_start_date
    },
    "tenant.mode": function (mode) {
      if (mode === 'transport_disposal' && this.tenant.disposal_subscribers_attributes.length === 0) {
        this.addDisposalSubscriber()
      }

      if (mode === 'disposal' && Array.isArray(this.tenant.disposal_subscribers_attributes)) {
        const hasOnlyNullIds = this.tenant.disposal_subscribers_attributes.length > 0 &&
          this.tenant.disposal_subscribers_attributes.every(item => item.id === null)
        if (hasOnlyNullIds) {
          this.tenant.disposal_subscribers_attributes = []
        }
      }
    },
    "tenant.use_proxy_entry": function (useProxyEntry) {
      if (useProxyEntry && this.tenant.proxy_entry_subscribers_attributes.length === 0) {
        this.addProxyEntrySubscriber()
      }
    },
  },
  created() {
    this.registed_formally_contract_date = this.tenant.formally_contract_date
    // DB値がカレンダーで選択状態となるようyyyy-mmに編集し、v-modelにセット
    if (this.tenant.ec_contract_invoice_start_date !== null){
      this.picker_ecContract_date = moment(this.tenant.ec_contract_invoice_start_date).format("YYYY-MM")
    }
    // DB値がカレンダーで選択状態となるようyyyy-mmに編集し、v-modelにセット
    if (this.tenant.ip_restrictions_invoice_start_date !== null) {
      this.picker_ipRestrictions_date = moment(this.tenant.ip_restrictions_invoice_start_date).format("YYYY-MM")
    }
    // DB値がカレンダーで選択状態となるようyyyy-mmに編集し、v-modelにセット
    if (this.tenant.api_invoice_start_date !== null) {
      this.picker_api_date = moment(this.tenant.api_invoice_start_date).format("YYYY-MM")
    }
    // DB値がカレンダーで選択状態となるようyyyy-mmに編集し、v-modelにセット
    if (this.tenant.jwnet_transfer_invoice_start_date !== null) {
      this.picker_jwnet_transfer_date = moment(this.tenant.jwnet_transfer_invoice_start_date).format("YYYY-MM")
    }
    // DB値がカレンダーで選択状態となるようyyyy-mmに編集し、v-modelにセット
    if (this.tenant.proxy_entry_invoice_start_date !== null) {
      this.picker_proxy_entry_date = moment(this.tenant.proxy_entry_invoice_start_date).format("YYYY-MM")
    }
  },
  methods: {
    /**
     * 請求情報（基本料金）
     * 正式契約日変更　コールバック
     */
    formallyContractDateChangedCallback (value) {
      this.tenant.formally_contract_date = value;
    },
    /**
     * 請求情報（基本料金）
     * 月額料金改定日変更　コールバック
     */
    saasPriceRevDateChangedCallback (value) {
      this.tenant.saas_price_rev_date = value;
    },
    /**
     * 請求情報（基本料金）
     * サービス利用停止日変更　コールバック
     */
    serviceStopDateChangedCallback (value) {
      this.tenant.service_stop_date = value;
    },
    /**
     * 請求情報（電子契約）
     * 電子契約利用開始日変更　コールバック
     */
    ecContractStartDateChangedCallback (value) {
      this.tenant.ec_contract_start_date = value;
    },
    /**
     * 請求情報（電子契約）
     * 電子契約利用終了日変更　コールバック
     */
    ecContractEndDateChangedCallback (value) {
      this.tenant.ec_contract_end_date = value;
    },
    /**
     * 請求情報（電子契約）
     * 請求開始日変更　コールバック
     */
    ecContractInvoiceStartDateChangedCallback (value) {
      if (value) {
        this.tenant.ec_contract_invoice_start_date = moment(value).format('YYYY-MM') + '-01'
      } else {
        this.tenant.ec_contract_invoice_start_date = null
      }
    },
    /**
     * 請求情報（電子契約）
     * 月額料金改定日変更　コールバック
     */
    ecContractPriceRevDateChangedCallback (value) {
      this.tenant.ec_contract_price_rev_date = value;
    },
    /**
     * 請求情報（IPアドレス制限）
     * IPアドレス制限利用開始日変更　コールバック
     */
    ipRestrictionsFormallyContractDateChangedCallback (value) {
      this.tenant.ip_restrictions_formally_contract_date = value;
    },
    /**
     * 請求情報（IPアドレス制限）
     * IPアドレス制限利用終了日変更　コールバック
     */
    ipRestrictionsServiceStopDateChangedCallback (value) {
      this.tenant.ip_restrictions_service_stop_date = value;
    },
    /**
     * 請求情報（IPアドレス制限）
     * 請求開始日変更　コールバック
     */
    ipRestrictionsInvoiceStartDateChangedCallback (value) {
      if (value) {
        this.tenant.ip_restrictions_invoice_start_date = moment(value).format('YYYY-MM') + '-01'
      } else {
        this.tenant.ip_restrictions_invoice_start_date = null
      }
    },
    /**
     * 請求情報（IPアドレス制限）
     * 月額料金改定日変更　コールバック
     */
    ipRestrictionsPriceRevDateChangedCallback (value) {
      this.tenant.ip_restrictions_price_rev_date = value;
    },
    /**
     * 請求情報（API）
     * API利用開始日変更　コールバック
     */
    apiStartDateChangedCallback (value) {
      this.tenant.api_start_date = value;
    },
    /**
     * 請求情報（API）
     * API利用終了日変更　コールバック
     */
    apiEndDateChangedCallback (value) {
      this.tenant.api_end_date = value;
    },
    /**
     * 請求情報（API）
     * 請求開始日変更　コールバック
     */
    apiInvoiceStartDateChangedCallback (value) {
      if (value) {
        this.tenant.api_invoice_start_date = moment(value).format('YYYY-MM') + '-01'
      } else {
        this.tenant.api_invoice_start_date = null
      }
    },
    /**
     * 請求情報（API）
     * 月額料金改定日変更　コールバック
     */
    apiPriceRevDateChangedCallback (value) {
      this.tenant.api_price_rev_date = value;
    },
    /**
     * 請求情報（freee請求連携）
     * freee利用開始日変更　コールバック
     */
    freeeStartDateChangedCallback (value) {
      this.tenant.freee_start_date = value;
    },
    /**
     * 請求情報（freee請求連携）
     * freee利用終了日変更　コールバック
     */
    freeeEndDateChangedCallback (value) {
      this.tenant.freee_end_date = value;
    },
    /**
     * 請求情報（freee請求連携）
     * 請求開始日変更　コールバック
     */
    freeeInvoiceStartDateChangedCallback (value) {
      if (value) {
        this.tenant.freee_invoice_start_date = moment(value).format('YYYY-MM') + '-01'
      } else {
        this.tenant.freee_invoice_start_date = null
      }
    },
    /**
     * 請求情報（freee請求連携）
     * 月額料金改定日変更　コールバック
     */
    freeePriceRevDateChangedCallback (value) {
      this.tenant.freee_price_rev_date = value;
    },
    /**
     * 請求情報（JWNETデータ取込）
     * JWNETデータ取込利用開始日変更　コールバック
     */
    jwnetTransferStartDateChangedCallback (value) {
      this.tenant.jwnet_transfer_start_date = value;
    },
    /**
     * 請求情報（JWNETデータ取込）
     * JWNETデータ取込利用終了日変更　コールバック
     */
    jwnetTransferEndDateChangedCallback (value) {
      this.tenant.jwnet_transfer_end_date = value;
    },
    /**
     * 請求情報（JWNETデータ取込）
     * 請求開始日変更　コールバック
     */
    jwnetTransferInvoiceStartDateChangedCallback (value) {
      if (value) {
        this.tenant.jwnet_transfer_invoice_start_date = moment(value).format('YYYY-MM') + '-01'
      } else {
        this.tenant.jwnet_transfer_invoice_start_date = null
      }
    },
    /**
     * 請求情報（JWNETデータ取込）
     * 月額料金改定日変更　コールバック
     */
    jwnetTransferPriceRevDateChangedCallback (value) {
      this.tenant.jwnet_transfer_price_rev_date = value;
    },
    /**
     * 請求情報（他社区間代行起票）
     * 他社区間代行起票利用開始日変更　コールバック
     */
    proxyEntryStartDateChangedCallback (value) {
      this.tenant.proxy_entry_start_date = value;
    },
    /**
     * 請求情報（他社区間代行起票）
     * 他社区間代行起票利用終了日変更　コールバック
     */
    proxyEntryEndDateChangedCallback (value) {
      this.tenant.proxy_entry_end_date = value;
    },
    /**
     * 請求情報（他社区間代行起票）
     * 請求開始日変更　コールバック
     */
    proxyEntryInvoiceStartDateChangedCallback (value) {
      if (value) {
        this.tenant.proxy_entry_invoice_start_date = moment(value).format('YYYY-MM') + '-01'
      } else {
        this.tenant.proxy_entry_invoice_start_date = null
      }
    },
    /**
     * 請求情報（他社区間代行起票）
     * 月額料金改定日変更　コールバック
     */
    proxyEntryPriceRevDateChangedCallback (value) {
      this.tenant.proxy_entry_price_rev_date = value;
    },
    
    /**
     * 処分事業者 加入者番号 追加ボタンコールバック
     */
    addDisposalSubscriber() {
      let time = new Date().getTime()
      this.tenant.disposal_subscribers_attributes.push({
        id: null,
        key: time,
        subscriber_number: null,
        confirmation_number: null,
        edi_usage_key: null,
        _destroy: false,
      })
    },
    /**
     * 処分事業者 加入者番号 削除ボタンコールバック
     */
    removeDisposalSubscriber(item) {
      let disposal = this.tenant.disposal_subscribers_attributes.find(v => v.key === item.key)
      if (disposal) {
        disposal._destroy = true
      }
    },
    /**
     * 他社区間代行起票 収運加入者 追加ボタンコールバック
     */
    addProxyEntrySubscriber() {
      let time = new Date().getTime()
      this.tenant.proxy_entry_subscribers_attributes.push({
        id: null,
        key: time,
        name: null,
        subscriber_number: null,
        confirmation_number: null,
        _destroy: false,
      })
    },
    /**
     * 他社区間代行起票 収運加入者 削除ボタンコールバック
     */
    removeProxyEntrySubscriber(item) {
      let proxyEntry = this.tenant.proxy_entry_subscribers_attributes.find(v => v.key === item.key)
      if (proxyEntry) {
        proxyEntry._destroy = true
      }
    },
    /**
     * その他請求項目 追加ボタンコールバック
     */
     addInvoiceOther() {
      let time = new Date().getTime()
      this.tenant.invoice_others_attributes.push({
        id: null,
        key: time,
        others_price: null,
        others_invoice_date: null,
        others_title: null,
        _destroy: false,
        enabled: true,
      })
    },
    /**
     * その他請求項目 削除ボタンコールバック
     */
    removeInvoiceOther(item) {
      let invoice = this.tenant.invoice_others_attributes.find(v => v.key === item.key)
      if (invoice) {
        invoice._destroy = true
      }
    },
    /**
     * SaaS月額利用料の算出
     */
    monthlyUsageFee() {
      if (this.tenant.mode === 'transport_disposal') {
        /** ライトプラン */
        if (this.tenant.price_plan === 'entry_plan') {
          this.tenant.saas_monthly_price = 60000
        /** スタンダードプラン */
        } else if (this.tenant.price_plan === 'standard_plan') {
          this.tenant.saas_monthly_price = 80000
        /** お試しプラン */
        } else if (this.tenant.price_plan === 'trial_plan') {
          this.tenant.saas_monthly_price = 10000
        /** 電子契約単体プラン */
        } else {
          this.tenant.saas_monthly_price = 0
        }
      } else {
        /** ライトプラン */
        if (this.tenant.price_plan === 'entry_plan') {
          this.tenant.saas_monthly_price = 30000
        /** スタンダードプラン */
        } else if (this.tenant.price_plan === 'standard_plan') {
          this.tenant.saas_monthly_price = 80000
        /** お試しプラン */
        } else if (this.tenant.price_plan === 'trial_plan') {
          this.tenant.saas_monthly_price = 10000
        /** 電子契約単体プラン */
        } else {
          this.tenant.saas_monthly_price = 0
        }
      }
    },
    /**
     * 取得した住所の反映
     * @param content
     */
    setZipAddress(content) {
      this.tenant.prefecture_code = `${content.pref_code}`
      this.tenant.address_1 = `${content.locality}`
      this.tenant.address_2 = `${content.street}`
    },
    /**
     * ピッカーで選択した日付に「-01」を付与し、項目：請求開始日にセット
     * @param type（種別：'ecContract' or 'ipRestrictions' or 'api'）
     * @param pickerdate（ピッカーで選択した年月 YYYY-MM）
     */
    formatDate(type,pickerdate) {
      if (type === 'ecContract'){
        this.ecContractDatePicker = false
        this.tenant.ec_contract_invoice_start_date = pickerdate  + '-01'
      } else if (type === 'ipRestrictions') {
        this.ipRestrictionsDatePicker = false
        this.tenant.ip_restrictions_invoice_start_date = pickerdate + '-01'
      } else if (type === 'freee') {
        this.freeeDatePicker = false
        this.tenant.freee_invoice_start_date = pickerdate  + '-01'
      } else if (type === 'api') {
        this.apiDatePicker = false
        this.tenant.api_invoice_start_date = pickerdate  + '-01'
      } else if (type === 'jwnet_transfer') {
        this.jwnetTransferDatePicker = false
        this.tenant.jwnet_transfer_invoice_start_date = pickerdate  + '-01'
      } else if (type === 'proxy_entry') {
        this.proxyEntryDatePicker = false
        this.tenant.proxy_entry_invoice_start_date = pickerdate  + '-01'
      }
    },
  },
}

</script>

<style scoped></style>
